var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "faq-wrapper" }, [
    _c("div", { staticClass: "faq-anchor-wrapper" }, [
      _c("div", { ref: _vm.faqRef, staticClass: "faq-anchor" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12", on: { click: _vm.toggleShowAnswer } },
        [
          _c(
            "div",
            { staticClass: "question-wrapper d-flex justify-content-between" },
            [
              _c("div", [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.faq.question) } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-arrow-wrapper pl-4" }, [
                _c("img", {
                  staticClass: "float-right dropdown-arrow align-middle",
                  class: [_vm.showAnswer ? "expanded" : "collapsed"],
                  attrs: {
                    src: require("@/assets/dropdown_arrow.svg"),
                    alt: "Dropdown arrow"
                  }
                })
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.showAnswer
        ? _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "answer-wrapper pt-4" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.faq.answer) } })
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ac9aeca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ac9aeca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeFaqCollapsible.vue
// module id = null
// module chunks = 